import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import useTenantsInMarketWithFocusArea from "../../hooks/useTenantsInMarketWithFocusArea";
import { useTenantInMarketStore } from "../../index";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import useTenantsInMarketWithGlobalFilters from "../../interfaces/useTenantsInMarketWithGlobalFilters";
import TenantsInMarketGrid from "../tenantsInMarket/TenantsInMarketGrid";

function CompanyDetailsTenantsInMarketTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const tenantInMarketStore = useTenantInMarketStore();
    const tenantsInMarket = useTenantsInMarketWithFocusArea(useTenantsInMarketWithGlobalFilters(
        useMemo(() => computed(() => tenantInMarketStore.tenantsInMarket.filter(tim => tim.pipedriveCompanyId?.toString() === id || tim.pipedriveBrokerageId?.toString() === id)), [id]).get()
    ));

    useEffect(() => setEntityCount(tenantsInMarket.length), [tenantsInMarket]);

    if (!visible)
        return null;

    return (
        <TenantsInMarketGrid tenantsInMarket={tenantsInMarket} />
    );
}

export default observer(CompanyDetailsTenantsInMarketTab);